import Colors from "types/globals/styleguide/colors";

const UpdateStyleguideAction: string = "UPDATE_STYLEGUIDE";

interface ReduxStyleguide {
  colors: Colors;
  breakpoint: number;
  isPortrait: boolean;
  mobile: boolean;
  innerWidth: number;
  innerHeight: number;
  maximumBodyWidth: number;
  maximumBlogWidth: number;
  containerWidth: number;
  margin: number;
  gutter: number;
  navigationBarHeight: number;
}

export default ReduxStyleguide;

export { UpdateStyleguideAction };
